import React from "react";

export default function MainContent({ children }) {
  return (
    <div className="flex flex-col w-full">
      {children}
    </div>
  );
}
